/**
 * Accent tones for card actions, chosen for the surface the card is on.
 *
 * Cards carry hardcoded accent colours in a lot of places — `text-purple-600`
 * and friends — picked against a white card. The dark themes use saturated
 * card backgrounds (blue-800, purple-800…), where those shades are close to
 * invisible.
 *
 * Tailwind's `dark:` variant is not the way out. This app is on Tailwind v4,
 * where class-based dark mode has to be opted into with a CSS
 * `@custom-variant` that the stylesheet does not declare — so `dark:` follows
 * the operating system, not the theme the user picked. A dark theme on a light
 * Mac takes the light branch every time. `isDark` from useTheme() is the only
 * signal that tracks the actual theme.
 *
 * Neutral actions get a translucent wash rather than a solid light fill: a
 * solid one turns the button near-white and takes the (white) label with it.
 *
 * @param {boolean} isDark
 */
export const actionTones = (isDark) => ({
  neutral: isDark ? 'border-white/30 text-white hover:bg-white/10'
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50',
  flyer:   isDark ? 'border-purple-400/60 text-purple-200 hover:bg-purple-400/10'
                  : 'border-purple-300 text-purple-600 hover:bg-purple-50',
  share:   isDark ? 'border-blue-400/60 text-blue-200 hover:bg-blue-400/10'
                  : 'border-blue-300 text-blue-600 hover:bg-blue-50',
  assign:  isDark ? 'border-green-400/60 text-green-200 hover:bg-green-400/10'
                  : 'border-green-300 text-green-600 hover:bg-green-50',
  delete:  isDark ? 'border-red-400/60 text-red-200 hover:bg-red-400/10'
                  : 'border-red-200 text-red-500 hover:bg-red-50',
});

export default actionTones;
